import { gql } from '@apollo/client';

export default gql`
  query areTicketsInSalesforce($bookingReference: String!, $ticketNumbers: [String!]!) {
    areTicketsInSalesforce(bookingReference: $bookingReference, ticketNumbers: $ticketNumbers)
  }
`;
